import { Box, Flex, Heading, Stack, Text } from "@chakra-ui/react";
import LocalSpinner from "../../../../components/LocalSpinner";
import { getFormattedNumValue } from "../../../../utils";
import { ChartPieSlice, TrendDown, TrendUp } from "@phosphor-icons/react";
import DashboardCard from "../../../ISSB/Dashboard/components/DashboardCard";

/**
 * @param {Object} p
 * @param {Object} p.currentYear Comes from useGetSupplierOverviewData
 * @param {Object} p.previousYear
 * @param {string} p.theme
 * @returns {JSX.Element}
 */
const ActiveSupplierCard = ({ isLoading, currentYear, previousYear, theme = "light" }) => {
  const colors = {
    light: {
      cardBg: "#F7FAFC",
      title: "teal",
      value: "gray.800",
      percentUp: "status.red",
      percentDown: "status.green",
    },
    dark: {
      cardBg: "pureBlack",
      title: "pureWhite",
      value: "lightLime",
      percentUp: "status.red",
      percentDown: "status.green",
    },
  };
  const t = colors[theme] || colors.light;

  let basePercentageChange = 0;
  // calculate percentage change based on currentYear and previousYear using totalSpend
  const previousSpend = previousYear?.spendsForEmissionDeclaredSupplier || 0;
  const currentSpend = currentYear?.spendsForEmissionDeclaredSupplier || 0;
  if (previousSpend > 0) {
    basePercentageChange = ((currentSpend - previousSpend) / previousSpend) * 100;
  }

  let spendPercentage = 0;
  // percent of currentYear.spendsForEmissionDeclaredSupplier compare to currentYear.totalSpend
  spendPercentage = ((currentYear?.spendsForEmissionDeclaredSupplier || 0) / (currentYear?.totalSpend || 1)) * 100;

  return (
    <DashboardCard bg={t.cardBg} px={6}>
      <Text fontSize="body.m" fontWeight="bold" color={t.title}>
        Active Suppliers
      </Text>
      {isLoading ? (
        <LocalSpinner size="sm" />
      ) : (
        <Flex direction="column" gap={8} height="100%" justify="space-between">
          <Box color="teal" mb={4}>

            <Heading fontSize="heading.2xl" >
            <Flex align="center" m={0} p={0}>
              <Text fontSize="heading.4xl" fontWeight="bold" color="teal.900" display="flex" alignItems="center">
                {currentYear?.totalSuppliersWithData || 0}
              </Text>
              <Text fontSize="heading.2xl" color="gray.400" pt={2}>
                {currentYear?.supplierCountWithRequestedData || 0}
              </Text>
            </Flex>
            </Heading>
          </Box>

          <Box>
            <Text fontSize="heading.s" fontWeight="bold">
              Spend
            </Text>
            <Text fontSize="heading.xl" fontWeight="bold">
              £ {getFormattedNumValue(currentYear?.spendsForEmissionDeclaredSupplier, 2, true) || 0}
            </Text>
            <Text>Company provided (£1m)</Text>
          </Box>

          <Box mt={4}>
            <Flex
              direction="row"
              width="100%"
              // px="15%"
              justifyContent="space-between"
            >
              <Text
                // display="flex"
                gap={1}
                fontSize="heading.s"
                color={basePercentageChange >= 0 ? t.percentUp : t.percentDown}
                fontWeight="bold"
              >
                {basePercentageChange >= 0 ? (
                  <TrendUp size={18} weight="bold" />
                ) : (
                  <TrendDown size={18} weight="bold" />
                )}
                {getFormattedNumValue(basePercentageChange, 2) || 0} %
                <br />
                Base
              </Text>
              <Text
                // display="flex"
                gap={1}
                fontSize="heading.s"
                fontWeight="bold"
              >
                <ChartPieSlice size={18} weight="bold" />
                {getFormattedNumValue(spendPercentage, 2) || 0} %
                <br />
                Spend
              </Text>
            </Flex>
          </Box>
        </Flex>
      )}
    </DashboardCard>
  );
};

export default ActiveSupplierCard;
